// TripDetails.js
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Typography,
  Timeline,
  Button,
  Tabs,
  Table,
  Form,
  Input,
  message,
  Card,
  Col,
  Row,
  Space,
  notification,
  Popconfirm,
} from "antd";
import {
  EnvironmentOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import ExpensesTab from "./expenseTab";
import colors from "../../assets/styles/colour";
import dataService from "../../networks/api/service/dataService";
const { Title, Text } = Typography;
const { TabPane } = Tabs;

const TripDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const trip = location.state?.trip;
  const [form] = Form.useForm();

  const [expenses, setExpenses] = useState([
    { key: 1, item: "Fuel", amount: 1200 },
    { key: 2, item: "Lunch", amount: 800 },
  ]);

  if (!trip) {
    return <Text>No trip data available.</Text>;
  }

  const MapPreview = ({ coordinates }) => (
    <MapContainer center={coordinates[0]} zoom={10} style={{ height: 400 }}>
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {coordinates.map((coord, index) => (
        <Marker position={coord} key={index}>
          <Popup>Checkpoint {index + 1}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );

  const handleEditTrip = (trip) => {
    navigate("/login/add-trip", { state: { tripToEdit: trip } });
  };
  const handleDeleteTrip = async (id) => {
    try {
       const response = await dataService.deleteTrip(id);
     console.log("huhua",response);
      message.success("Trip deleted successfully");
      navigate("/login/trip-management");
    } catch (error) {
      message.error("Failed to delete trip");
    }
  };

  return (
    <div style={{ maxWidth: 1200, margin: "30px 10px", padding: 20 }}>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(-1)}
        style={{
          marginBottom: 20,
          background: colors.buttoSecondary,
          color: colors.textSecondary,
        }}
      >
        Back
      </Button>

      <Title level={3}>Trip Details</Title>

      <Tabs
        defaultActiveKey="1"
        style={{
          background: "#fff",
          borderRadius: 10,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          padding: 10,
        }}
      >
        {/* Overview Tab */}
        <TabPane tab="Overview" key="1">
          <Card bordered={false}>
            <Title level={4}>Trip Overview</Title>
            <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
              <Col span={12}>
                <Text>
                  <b>Start Date:</b>{" "}
                  {new Date(trip.startDateTime).toLocaleString()}
                </Text>
              </Col>
              <Col span={12}>
                <Text>
                  <b>End Date:</b> {new Date(trip.endDateTime).toLocaleString()}
                </Text>
              </Col>
              <Col span={12}>
                <Text>
                  <b>Trip Type:</b> {trip.tripType}
                </Text>
              </Col>
              <Col span={12}>
                <Text>
                  <b>Vehicle:</b> {trip.vehicle?.makeAndModel || "N/A"}
                </Text>
              </Col>
              <Col span={12}>
                <Text>
                  <b>Driver:</b> {trip.driver?.driverName || "N/A"}
                </Text>
              </Col>
              <Col span={12}>
                <Text>
                  <b>Phone:</b> {trip.driver?.driverPhoneNumber}
                </Text>
              </Col>
              <Col span={12}>
                <Text>
                  <b>StartPoint:</b> {trip.startPoint}
                </Text>
              </Col>
              <Col span={12}>
                <Text>
                  <b>EndPoint:</b> {trip.endPoint}
                </Text>
              </Col>
              <Col span={12}>
                <Text>
                  <b>Persons:</b> {trip.personsInTrip}
                </Text>
              </Col>
              <Col span={12}>
                <Text>
                  <b>Distance:</b> {trip.distanceTraveled} km
                </Text>
              </Col>
              <Col span={24}>
                <Text>
                  <b>Description:</b> {trip.description}
                </Text>
              </Col>
            </Row>
          </Card>
        </TabPane>

        {/* Timeline Tab */}
        <TabPane tab="Edit Or Delete" key="2">
          <Card bordered={false}>
            <Title level={4}>Trip Management</Title>

            <Table
              dataSource={[trip]}
              rowKey="_id"
              columns={[
                {
                  title: "Trip",
                  dataIndex: "startPoint",
                  render: (_, record) =>
                    `${record.startPoint} ➝ ${record.endPoint}`,
                },
                {
                  title: "Driver",
                  dataIndex: "driverName",
                  render: (_,record) =>
                    `${record.driver?.driverName}`,
                },
                {
                  title: "Vehicle",
                  dataIndex: "vehicleName",
                  render: (_,record) =>
                    `${record.vehicle?.makeAndModel}`,
                },

                {
                  title: "Actions",
                  render: (_, record) => (
                    <Space>
                      <Button
                        icon={<EditOutlined />}
                        type="link"
                        onClick={() => handleEditTrip(record)}
                      >
                        Edit
                      </Button>

                      <Popconfirm
                        title="Are you sure to delete this trip?"
                        onConfirm={() => handleDeleteTrip(record._id)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button icon={<DeleteOutlined />} type="link" danger>
                          Delete
                        </Button>
                      </Popconfirm>
                    </Space>
                  ),
                },
              ]}
            />
          </Card>
        </TabPane>

        {/* Report Tab */}
        <TabPane tab="Report" key="3">
          <Card bordered={false}>
            <Title level={4}>Trip Report</Title>
            <Text>{trip.report || "No Report"}</Text>
          </Card>
        </TabPane>

        {/* Map Preview */}
        <TabPane tab="Map Preview" key="4">
          <Card bordered={false}>
            <Title level={4}>Map Preview</Title>
            {/* <MapPreview
              coordinates={[
                [19.076, 72.877],
                [18.5204, 73.8567],
              ]}
            /> */}
          </Card>
        </TabPane>

        {/* Expenses Tab */}
        <TabPane tab="Expenses" key="6">
          <Card bordered={false}>
            <ExpensesTab />
          </Card>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default TripDetails;
